
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationcabsfrompimprichichwad() {



    const cardData =
    {
        keyword: 'Outstation Cabs from Pimpri Pune',
        heading: 'Platinum24 Cabs: Outstation Cabs from Pimpri Pune',
        headingDescription: ' Platinum24 Cabs provides reliable Outstation Cabs from Pimpri Pune, perfect for weekend getaways, family trips, corporate travel, and pilgrimage tours. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable ride on long-distance routes. With professional chauffeurs, timely pickups, and transparent fares, we make outstation travel from Pimpri hassle-free and affordable. Whether you’re heading to Mumbai, Shirdi, Mahabaleshwar, Goa, or other popular destinations, Platinum24 Cabs guarantees 24/7 availability, clean vehicles, and dependable service for every outstation journey from Pimpri Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


      "services": [
    {
      "name": "Pimpri Outstation Cab Service",
      "description": "Our Pimpri Outstation Cab Service offers reliable and comfortable transportation for long-distance travel from Pimpri to various destinations. Whether it's a business trip, weekend getaway, or family vacation, enjoy well-maintained vehicles, professional drivers, and flexible scheduling to ensure a smooth and hassle-free journey."
    },
    {
      "name": "Outstation Taxi Pimpri",
      "description": "Travel beyond city limits with our Outstation Taxi service in Pimpri. We provide safe, affordable, and timely taxi services for outstation trips, with options for round trips and one-way travel, making your long-distance rides convenient and stress-free."
    },
    {
      "name": "Pimpri Taxi Booking Outstation",
      "description": "Book your outstation taxi in Pimpri effortlessly through our easy-to-use online platform or phone booking. Enjoy instant confirmations, customizable trip plans, and 24x7 customer support to cater to all your travel needs outside Pimpri."
    },
    {
      "name": "Affordable Outstation Cabs Pimpri",
      "description": "Get premium outstation cab services in Pimpri at affordable rates. Our transparent pricing and special discounts ensure that you receive the best value for your money without compromising on safety or comfort during your long-distance trips."
    },
    {
      "name": "Pimpri Outstation Taxi Hire",
      "description": "Hire outstation taxis in Pimpri with flexible rental packages tailored to your travel duration and destination. Our experienced drivers and clean vehicles guarantee a safe and enjoyable ride for all your outstation requirements."
    },
    {
      "name": "Pimpri Outstation Cab with Driver",
      "description": "Experience stress-free travel with our outstation cab service in Pimpri that includes professional drivers familiar with regional routes and traffic patterns. Enjoy safe journeys with courteous service and timely pickups."
    },
    {
      "name": "Pimpri Outstation Cab Packages",
      "description": "Choose from a variety of outstation cab packages in Pimpri designed to fit your budget and travel plans. Whether for weekend trips, corporate travel, or sightseeing tours, our packages offer convenience, cost-effectiveness, and comfort."
    },
    {
      "name": "Pimpri Outstation Taxi Fare",
      "description": "Our Pimpri Outstation Taxi Fare is competitively priced with no hidden charges. Transparent fare calculations based on distance, vehicle type, and trip duration ensure you know exactly what you pay for, giving you peace of mind for your travel expenses."
    },
    {
      "name": "Pimpri Outstation Cab Deals",
      "description": "Avail exclusive deals and discounts on Pimpri outstation cabs for frequent travelers, corporate clients, and long-distance journeys. Our special offers make premium taxi services affordable and accessible for everyone."
    },
    {
      "name": "Pimpri Outstation Taxi Service 24x7",
      "description": "Our outstation taxi services in Pimpri are available 24x7, providing round-the-clock booking and support for your travel needs. Whether you need an early morning pickup or late-night drop, we ensure reliable and timely service at all hours."
    },
    {
      "name": "Pimpri Outstation Cab Rental",
      "description": "Rent outstation cabs in Pimpri for short or extended durations with flexible rental options. Perfect for families, groups, or corporate travel, our rental services provide comfort, reliability, and professional drivers for your long-distance trips."
    },
    {
      "name": "Pimpri Outstation Taxi Online Booking",
      "description": "Book your Pimpri outstation taxi online anytime with ease. Our seamless digital booking process, instant confirmations, and multiple payment options provide a hassle-free experience for planning your outstation journeys."
    },
    {
      "name": "Pimpri Weekend Outstation Cab",
      "description": "Plan your weekend getaways with our Pimpri Weekend Outstation Cab service. Enjoy specially curated packages, comfortable vehicles, and expert drivers to make your short trips relaxing and enjoyable."
    },
    {
      "name": "Pimpri Luxury Outstation Taxi",
      "description": "Travel in style with our Luxury Outstation Taxi service in Pimpri. Featuring premium vehicles and highly professional chauffeurs, this service is perfect for corporate clients and special occasions where comfort and class are a priority."
    },
    {
      "name": "Pimpri Outstation Taxi for Corporate",
      "description": "Our corporate outstation taxi service in Pimpri is designed to meet the professional transportation needs of businesses. Offering punctuality, privacy, and premium services, we cater to corporate events, client visits, and business travel with tailored packages."
    }
  ],
  "tableData": [
    ["Pimpri Outstation Cab Service", "Outstation Taxi Pimpri"],
    ["Pimpri Taxi Booking Outstation", "Affordable Outstation Cabs Pimpri"],
    ["Pimpri Outstation Taxi Hire", "Pimpri Outstation Cab with Driver"],
    ["Pimpri Outstation Cab Packages", "Pimpri Outstation Taxi Fare"],
    ["Pimpri Outstation Cab Deals", "Pimpri Outstation Taxi Service 24x7"],
    ["Pimpri Outstation Cab Rental", "Pimpri Outstation Taxi Online Booking"],
    ["Pimpri Weekend Outstation Cab", "Pimpri Luxury Outstation Taxi"],
    ["Pimpri Outstation Taxi for Corporate", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Reliable Outstation Cabs from Pimpri Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers dependable and comfortable outstation cab services starting from Pimpri Pune to various destinations."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Outstation Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes for a safe and timely journey beyond Pimpri Pune."
    },
    {
      "WhyChooseheading": "Clean and Well-Maintained Vehicles for Long Trips",
      "WhyChoosedescription": "Travel comfortably in sanitized, air-conditioned cabs suited for long-distance travel."
    },
    {
      "WhyChooseheading": "Flexible Booking Options – One-Way and Round Trip",
      "WhyChoosedescription": "Choose packages that fit your travel itinerary with convenient one-way or round trip options."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for worry-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our dedicated team is available around the clock to assist with your bookings and travel needs."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Corporate Travel, and Leisure Tours",
      "WhyChoosedescription": "Perfect for all kinds of travel plans from Pimpri Pune to nearby cities and beyond."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers depending on your comfort and luggage needs."
    }
  ]


























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer outstation cab services from Pimpri Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable outstation cab services from Pimpri Pune to various destinations.',
    },
    {
        question: 'How can I book outstation cabs from Pimpri Pune with Platinum24 Cabs?',
        answer: 'You can book outstation cabs easily through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for outstation trips from Pimpri Pune?',
        answer: 'We offer a range of vehicles including sedans, SUVs, tempo travellers, and premium cars suitable for outstation travel.',
    },
    {
        question: 'Are the drivers experienced for long-distance trips from Pimpri Pune?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about routes from Pimpri Pune to various destinations.',
    },
    {
        question: 'Can I book round-trip outstation cabs from Pimpri Pune?',
        answer: 'Absolutely! We offer round-trip cab services with flexible scheduling to suit your travel plans.',
    },
    {
        question: 'What is included in the fare for outstation cabs from Pimpri Pune?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for outstation cabs from Pimpri Pune?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Pimpri Pune and your destination.',
    },
    {
        question: 'Are safety measures in place for outstation cab rides from Pimpri Pune?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety protocols for your protection during outstation trips.',
    },
    {
        question: 'Is it possible to hire outstation cabs from Pimpri Pune for multiple days?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your outstation travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate outstation taxi services from Pimpri Pune?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for outstation routes from Pimpri Pune.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vikram Joshi',
        feedback: 'The outstation cab service from Pimpri Pune by Platinum24 Cabs was excellent. The driver was courteous and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Rao',
        feedback: 'Booking an outstation cab from Pimpri Pune was seamless. Great service and punctual drivers.',
        rating: 5,
    },
];

































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const pimpriOutstationTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable outstation cab service from Pimpri Pune offering taxi hire with driver, packages, corporate travel, and luxury outstation taxis available 24x7.",
  "areaServed": {
    "@type": "Place",
    "name": "Pimpri, Pune"
  },
  "serviceType": [
    "Pimpri Outstation Cab Service",
    "Outstation Taxi Pimpri",
    "Pimpri Taxi Booking Outstation",
    "Affordable Outstation Cabs Pimpri",
    "Pimpri Outstation Taxi Hire",
    "Pimpri Outstation Cab with Driver",
    "Pimpri Outstation Cab Packages",
    "Pimpri Outstation Taxi Fare",
    "Pimpri Outstation Cab Deals",
    "Pimpri Outstation Taxi Service 24x7",
    "Pimpri Outstation Cab Rental",
    "Pimpri Outstation Taxi Online Booking",
    "Pimpri Weekend Outstation Cab",
    "Pimpri Luxury Outstation Taxi",
    "Pimpri Outstation Taxi for Corporate"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>
<Helmet>
  <title>Outstation Cabs from Pimpri Pune | Affordable Pimpri Outstation Taxi</title>
  <meta
    name="description"
    content="Affordable and reliable outstation cab service from Pimpri Pune offering taxi hire with driver, packages, corporate travel, and luxury outstation taxis available 24x7."
  />
  <meta
    name="keywords"
    content="Pimpri Outstation Cab Service, Outstation Taxi Pimpri, Pimpri Taxi Booking Outstation, Affordable Outstation Cabs Pimpri, Pimpri Outstation Taxi Hire, Pimpri Outstation Cab with Driver, Pimpri Outstation Cab Packages, Pimpri Outstation Taxi Fare, Pimpri Outstation Cab Deals, Pimpri Outstation Taxi Service 24x7, Pimpri Outstation Cab Rental, Pimpri Outstation Taxi Online Booking, Pimpri Weekend Outstation Cab, Pimpri Luxury Outstation Taxi, Pimpri Outstation Taxi for Corporate"
  />
  <script type="application/ld+json">
    {JSON.stringify(pimpriOutstationTaxiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/76.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Outstationcabsfrompimprichichwad;